/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeClipSchema } from '../challenge-clip-schema';

export const challengeClipV2Schema = challengeClipSchema.extend({
  verticalFileSizeKb: z.number().nullable().optional(),
});

export type IChallengeClipV2 = z.infer<typeof challengeClipV2Schema>;

export const updateClipCropStatusV2ResponseSchema = createApiResponseSchema(
  challengeClipV2Schema,
) as z.ZodSchema<IAPI<IChallengeClipV2>>;

export type IUpdateClipCropStatusV2Response = IAPI<IChallengeClipV2>;
